module.exports = __webpack_public_path__ + "static/Johnson__Adekunle-ea121a1c0d178820149db4d9247c3619.png";